module.exports = __webpack_public_path__ + "static/media/champion.5058aa8f.svg";